import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { PATH } from './routes';
import SignupHome from './pages/signup/components/SignupHome';
import OrganizationName from './pages/signup/steps/OrganizationName';
import UserTitle from './pages/signup/steps/UserTitle';
import UserName from './pages/signup/steps/UserName';
import UserEmail from './pages/signup/steps/UserEmail';
import UserPhoneNumber from './pages/signup/steps/UserPhoneNumber';
import EinNumber from './pages/signup/steps/EinNumber';
import FinalStep from './pages/signup/components/FinalStep';
import { Error404 } from './theme/components/ErrorPage';
import PasswordStep from './pages/signup/components/PasswordStep';
import DoneeType from './pages/signup/steps/DoneeType';
import HelpButton from './pages/signup/components/HelpButton';
import OrganizationSearch from './pages/signup/steps/OrganizationSearch';
import AddOrganization from './pages/signup/steps/OrganizationAdd';
import InviteDonee from './pages/signup/steps/InviteDonee';
import Welcome from './pages/signup/steps/Welcome';
import Activate from './pages/signup/steps/Activate';
import AcceptInvite from './pages/signup/steps/AcceptInvite';
import { useSelector } from 'react-redux';
import { loadFingerprint } from 'store/signup/thunks';
import { getEnabledFeatures } from 'store/featureFlags/thunks';
import { AppState } from 'store';
import { useAppDispatch } from 'store/hooks';
import { ConfirmOrganization } from 'pages/signup/steps/ConfirmOrganization';
import { SignupSubmitted } from 'pages/signup/steps/SignupSubmitted';

const AppRouter = () => {
    const dispatch = useAppDispatch();
    const { fingerprint } = useSelector((state: AppState) => ({
        fingerprint: state.Signup.fingerprint,
    }));

    useEffect(() => {
        dispatch(loadFingerprint());
    }, [dispatch]);

    useEffect(() => {
        if (!fingerprint) {
            return;
        }

        dispatch(getEnabledFeatures(fingerprint));
    }, [fingerprint, dispatch]);

    return (
        <>
            <HelpButton />
            <Routes>
                <Route path={PATH.SIGNUP.HOME} element={<SignupHome />} />
                <Route path={PATH.SIGNUP.WELCOME} element={<Welcome />} />
                <Route
                    path={PATH.SIGNUP.STEPS.ONE}
                    element={<OrganizationName />}
                />
                <Route
                    path={PATH.SIGNUP.STEPS.SEARCH_ORGANIZATION}
                    element={<OrganizationSearch />}
                />
                <Route
                    path={PATH.SIGNUP.STEPS.CONFIRM_ORGANIZATION}
                    element={<ConfirmOrganization />}
                />
                <Route
                    path={PATH.SIGNUP.STEPS.ADD_ORGANIZATION}
                    element={<AddOrganization />}
                />
                <Route
                    path={PATH.SIGNUP.STEPS.INVITE_DONEE}
                    element={<InviteDonee />}
                />
                <Route path={PATH.SIGNUP.STEPS.TWO} element={<DoneeType />} />
                <Route path={PATH.SIGNUP.STEPS.THREE} element={<UserName />} />
                <Route path={PATH.SIGNUP.STEPS.FOUR} element={<UserTitle />} />
                <Route path={PATH.SIGNUP.STEPS.FIVE} element={<UserEmail />} />
                <Route
                    path={PATH.SIGNUP.STEPS.SIX}
                    element={<UserPhoneNumber />}
                />
                <Route path={PATH.SIGNUP.STEPS.SEVEN} element={<EinNumber />} />
                <Route
                    path={PATH.SIGNUP.STEPS.FINAL_STEP}
                    element={<FinalStep />}
                />
                <Route
                    path={PATH.SIGNUP.STEPS.PASSWORD_STEP}
                    element={<PasswordStep />}
                />
                <Route
                    path={PATH.SIGNUP.SUBMITTED}
                    element={<SignupSubmitted />}
                />
                <Route path={PATH.SIGNUP.ACTIVATE} element={<Activate />} />
                <Route
                    path={PATH.SIGNUP.ACCEPT_INVITE}
                    element={<AcceptInvite />}
                />
                <Route path="*" element={<Error404 />} />
            </Routes>
        </>
    );
};

export default AppRouter;
